import { getScoreColor } from 'utils/helpers';
import styled from 'styled-components';
import { tooltips } from '@/copy';

const MeterWrapper = styled.div`
    background-color: ${({ theme }) => theme.gray_5};
    border-radius: 100px;
`;

const Meter = styled.div`
    display: block;
    background: ${({ score, $metricLabel }) =>
        getScoreColor(score, false, $metricLabel)};
    width: ${({ score }) =>
        typeof score !== 'number' ? '100%' : `${score * 10}%`};
    min-width: 5%;
    height: 8px;
    border-radius: 100px;
`;

export const MeterLabel = styled.div`
    color: ${({ score, $metricLabel }) =>
        getScoreColor(score, false, $metricLabel)};
    font-size: 14px;
    text-transform: capitalize;
`;

function HealthStatMeter({ score, scoreLabel, metricLabel }) {
    return (
        <>
            <MeterLabel score={score} $metricLabel={metricLabel}>
                {scoreLabel || tooltips.healthStatsMissingScoreLabel}
            </MeterLabel>
            <MeterWrapper
                title={`${score > 0 || score === 0 ? score : '\u2013'} / 10`}
            >
                <Meter score={score} $metricLabel={metricLabel} />
            </MeterWrapper>
        </>
    );
}

export default HealthStatMeter;
